import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Container,
  Box,
  Typography,
  Modal,
  TextField,
  Grid,
  IconButton,
  Switch,
  Paper,
  Select,
  MenuItem,
} from '@mui/material';
import { Amplify } from 'aws-amplify';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { LinkOff as UnlinkIcon } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { post, get } from 'aws-amplify/api';
import { Label, withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { v4 as uuidv4 } from 'uuid';
import config from './amplifyconfiguration.json';
import './App.css';

Amplify.configure(config);

const App = ({ signOut, user }) => {
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [currentBusiness, setCurrentBusiness] = useState({
    business_id: uuidv4(),
    schedule: 'Weekly',
    post_time: dayjs(),
    post_day: 'Monday',
    post_month_day: 1,
  });
  const [xHandle, setXHandle] = useState('')
  const [username, setUsername] = useState(user.username);

  const [subscriptions, setSubscriptions] = useState({});
  const [subscriptionModalIsOpen, setSubScriptionModalIsOpen] = useState(false);

  const [editing, setEditing] = useState(false);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const options = ['Contact Us', 'Subscriptions'];
  const settings = ['Logout'];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (option) => {
    if(option === 'Contact Us') {
      handleContactUs();
    } else if (option === 'Subscriptions') {
      handleSubscriptionModalOpen();
    }
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (setting) => {
    if(setting === "Logout") {
      signOut();
    }
    setAnchorElUser(null);
  };

  const handleOpenModal = () => {
    if(subscriptions.subs > businesses.length){
      setOpenModal(true);
    } else {
      alert('You have reached the maximum number of businesses. Please add a subscription to add more businesses.');
    }
  }

  const handleCloseModal = () => { 
    setOpenModal(false); 
    setEditing(false);
    
    setCurrentBusiness({
      business_id: uuidv4(),
      schedule: 'Weekly',
      post_time: dayjs(),
      post_day: 'Monday',
      post_month_day: 1,
    });
  }

  const handleSubscriptionModalClose = () => setSubScriptionModalIsOpen(false);
  const handleSubscriptionModalOpen = () => setSubScriptionModalIsOpen(true);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleEditBusiness = (business_id) => {
    setEditing(true);
    dayjs.extend(customParseFormat);
    const biz = businesses.find((business) => business.business_id === business_id);
    console.log(dayjs(biz.post_time, "HH:mm").format("hh:mm a"));
    biz.post_time = dayjs(biz.post_time, "HH:mm");

    setCurrentBusiness(biz);

    setOpenModal(true);
  }

  const handleDeleteBusiness = (business_id) => {
    try {
      const restOperation = post({
        apiName: 'accrevrest',
        path: '/business/delete',
        options: {
          body: {
            username: user.username,
            business_id: business_id
          },
        }
      });

      restOperation.response
        .then((response) => response.body.json())
        .then((body) => {
          console.log(body)
          setBusinesses((prevBusinesses) =>
            prevBusinesses.filter((business) => business.business_id !== business_id)
          );
        })
    } catch (error) {
      console.error('Error deleting business:', error);
    }
  };

  const handleUnlink = () => {
    try {
      const restOperation = post({
        apiName: 'accrevrest',
        path: '/xoauth/delete',
        options: {
          body: {
            username: user.username
          },
        }
      });

      restOperation.response
        .then((response) => response.body.json())
        .then((body) => {
          setXHandle('');
        })
    } catch (error) {
      console.error('Error unlinking X:', error);
    }
  };

  const toggleDropdownMenu = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentBusiness({
      ...currentBusiness,
      [name]: value,
    });
  };

  useEffect(() => {
    const getUserXAccountDetails = async () => {
      try {
        if (username !== '') {
          const restOperation = get({ 
            apiName: 'accrevrest',
            path: '/xoauth/details',
            options: {
              queryParams: {
                username: username
              }
            }
          });

          restOperation.response
            .then((response) => response.body.json())
            .then((body) => {
              if(body.x_setup) {
                setXHandle(body.screen_name)
              }
            })
        }
      } catch (error) {
        console.error('Error fetching X account:', error);
      }
    };

    const getUserBusinesses = async () => {
      try {
        if (username !== '') {
          const restOperation = get({ 
            apiName: 'accrevrest',
            path: '/business/list',
            options: {
              queryParams: {
                username: username
              }
            }
          });

          restOperation.response
            .then((response) => response.body.json())
            .then((body) => {
              setBusinesses(body);
            })
        }
      } catch (error) {
        console.error('Error fetching identities:', error);
      }
    };

    const getUserSubscriptions = async () => {
      try {
        if (username !== '') {
          const restOperation = get({ 
            apiName: 'accrevrest',
            path: '/stripe/subscription/list',
            options: {
              queryParams: {
                username: username
              }
            }
          });

          restOperation.response
            .then((response) => response.body.json())
            .then((body) => {
              if(!body.subs) {
                setSubscriptions({subs: 0});
              } else {
                setSubscriptions(body);
              }
            })
        }
      } catch (error) {
        console.error('Error fetching identities:', error);
      }
    };

    getUserXAccountDetails();
    getUserBusinesses();
    getUserSubscriptions();
  }, [username]);

  useEffect(() => {
    // Parse the tokens from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const oauthToken = urlParams.get('oauth_token');
    const oauthVerifier = urlParams.get('oauth_verifier');

    if(oauthToken && oauthVerifier) {
      // Make the API call to exchange the tokens for an access token
      try {
        const restOperation = post({
          apiName: 'accrevrest',
          path: '/xoauth/access-token',
          options: {
            body: {
              username: user.username,
              oauth_token: oauthToken,
              oauth_verifier: oauthVerifier,
            },
          }
        });
  
        restOperation.response
          .then((response) => response.body.json())
          .then((body) => {
            console.log(body)
            try {
              if (username !== '') {
                const restOperation = get({ 
                  apiName: 'accrevrest',
                  path: '/xoauth/details',
                  options: {
                    queryParams: {
                      username: username
                    }
                  }
                });
      
                restOperation.response
                  .then((response) => response.body.json())
                  .then((body) => {
                    if(body.x_setup) {
                      setXHandle(body.screen_name)
                    }
                  })
              }
            } catch (error) {
              console.error('Error fetching X account:', error);
            }
          })
      } catch (error) {
        console.error('Error updating business details:', error);
      }

    // Clean the URL by removing the tokens
    window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleTimeChange = (newValue) => {
    setCurrentBusiness({
      ...currentBusiness,
      post_time: newValue,
    });
  };

  const handleConnectX = () => {
    try {
      setLoading(true);
      const restOperation = post({
        apiName: 'accrevrest',
        path: '/xoauth/request-token',
        options: {
          
        }
      });

      restOperation.response
        .then((response) => response.body.json())
        .then((body) => {
          if (body.redirect_url) {
            window.location.href = body.redirect_url;
          }
        })
    } catch (error) {
      console.error('Error updating business details:', error);
      setLoading(false);
    }
  };

  const handleSaveBusiness = async () => {
    // Save business details using Amplify API

    console.log(currentBusiness);
    try {
      const restOperation = post({
        apiName: 'accrevrest',
        path: '/business/update',
        options: {
          body: {
            username: user.username,
            business_id: currentBusiness.business_id,
            schedule: currentBusiness.schedule,
            post_time: currentBusiness.post_time.format('HH:mm'),
            post_day: currentBusiness.post_day,
            post_month_day: currentBusiness.post_month_day,
            posting_enabled: currentBusiness.posting_enabled,
            business_name: currentBusiness.business_name,    
            post_introduction: currentBusiness.post_introduction,
            stripe_key: currentBusiness.stripe_key,
          },
        },
      });  

      if(!editing) {
        restOperation.response
          .then((response) => response.body.json())
          .then((body) => {
            setBusinesses([...businesses, currentBusiness]);
            setCurrentBusiness({
              business_id: uuidv4(),
              schedule: 'Weekly',
              post_time: dayjs(),
              post_day: 'Monday',
              post_month_day: 1,
            });
            setOpenModal(false);
          })
        } else {
          setBusinesses(businesses.map(
            (business) =>
              business.business_id === currentBusiness.business_id
                ? currentBusiness
                : business
          ));

          setCurrentBusiness({
            business_id: uuidv4(),
            schedule: 'Weekly',
            post_time: dayjs(),
            post_day: 'Monday',
            post_month_day: 1,
          });
          setEditing(false);
          setOpenModal(false);
        }
    } catch (error) {
      console.error('Error updating business details:', error);
    }
  };

  const handleTogglePosting = async (business_id) => {
    try {
      // Find the selected business using .find() instead of .map()
      const selectedBusiness = businesses.find(
        (business) => business.business_id === business_id
      );
  
      // If the business is not found, log a message and exit the function
      if (!selectedBusiness) {
        console.log('Business not found');
        return;
      }

      console.log('Selected Business:', selectedBusiness);
  
      // Toggle the postingEnabled status
      const newPostingEnabled = !selectedBusiness.posting_enabled;
      console.log('New Posting Enabled:', newPostingEnabled);
  
      // Make an API call to update the business details in DynamoDB
      const restOperation = post({
        apiName: 'accrevrest',
        path: '/business/update',
        options: {
          body: {
            username: user.username,
            business_id: business_id,
            posting_enabled: newPostingEnabled,
            stripe_key: selectedBusiness.stripe_key,
            business_name: selectedBusiness.business_name,
            post_introduction: selectedBusiness.post_introduction,
            schedule: selectedBusiness.schedule,
            post_time: selectedBusiness.post_time,
            post_day: selectedBusiness.post_day,
            post_month_day: selectedBusiness.post_month_day,
          },
        },
      });
  
      // Update the business state locally after a successful API call
      setBusinesses((prevBusinesses) =>
        prevBusinesses.map((b) =>
          b.business_id === business_id
            ? { ...b, posting_enabled: newPostingEnabled }
            : b
        )
      );
  
      console.log('Business updated successfully.');
  
    } catch (error) {
      console.error('Error updating business details:', error);
    }
  };
  

  const handleContactUs = () => {
    window.location.href = "mailto:accuraterevenue@gmail.com";
  };

  return (
    <div className="App">
      <AppBar position="static" style={{backgroundColor: 'white', paddingTop: '5px', paddingBottom: '5px'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo for desktop view */}
          <Box
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              display: { xs: 'none', md: 'flex' },
              mr: 1,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/accrev-logo.png`}
              alt="AccRev Logo"
              className="logo-image"
            />
          </Box>

          {/* Mobile menu button */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="black"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option} onClick={() => handleCloseNavMenu(option)}>
                  <Typography textAlign="center">{option}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Logo for mobile view */}
          <Box
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/accrev-logo.png`}
              alt="AccRev Logo"
              className="logo-image"
            />
          </Box>

          {/* Navigation buttons for desktop view */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {options.map((option) => (
              <Button
                key={option}
                onClick={() => handleCloseNavMenu(option)}
                sx={{ my: 2, color: 'white', display: 'block' }}
                style={{color: 'black'}}
              >
                {option}
              </Button>
            ))}
          </Box>

          {/* User settings */}
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
      {/*<header className="App-header">
      <div className="logo">
        <img src={`${process.env.PUBLIC_URL}/accrev-logo.png`} alt="AccRev Logo" className="logo-image" />
      </div>
      
      <div className="dropdown">
        <div className={`settings ${isDropdownOpen ? 'open' : ''}`}>
          <button className="header-button" onClick={handleContactUs}>
            Contact us
          </button>
          <button className="header-button" onClick={() => setSubScriptionModalIsOpen(true)}>
            Your Subscription
          </button>
          <button className="header-button" onClick={signOut}>
            Sign Out
          </button>
        </div>
      </div>
            </header>*/}
    <Container maxWidth="md">
      <Paper
          sx={{
            mt: 4,
            p: 4,
            borderRadius: 4,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
          elevation={3}
        >
          {xHandle === '' ? (
            <div>
              <img style={{width: '50px', height: '50px' }} src={`${process.env.PUBLIC_URL}/x-logo.png`} alt="X Logo" />
              <Typography variant="h5">Connect Your X Account</Typography>
              <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                Connect your X account to automate posting  of your MRR and customer metrics.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleConnectX}
              >
                Link Your Account
              </Button>
            </div>
          ) :
            <div>
              <img style={{width: '50px', height: '50px' }} src={`${process.env.PUBLIC_URL}/x-logo.png`} alt="X Logo" />
              <Typography variant="h6">Linked Handle @{xHandle}</Typography> 
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                startIcon={<UnlinkIcon />}
                onClick={handleUnlink}
              >
                Unlink
              </Button>
            </div>
          }
      </Paper>

      {loading && (
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      )}
      
      {/* Subscriptions Modal */}
      <Modal open={subscriptionModalIsOpen} onClose={handleSubscriptionModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id="modal-title" variant="h5" sx={{ mb: 2 }} style={{ textAlign: 'center' }}>
          Active Subscriptions
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Number of Active Subscriptions: {subscriptions.subs}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Button variant="contained" color="primary" onClick={() => { 
              window.location.href =
                'https://buy.stripe.com/dR615O8yk5db8fKfYY?client_reference_id=' + user.username  }}>
              Add Subscription
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>

      {/* Business Details Box */}
        {businesses.length === 0 ? (
          <Paper
          sx={{
            mt: 4,
            p: 4,
            borderRadius: 4,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
          elevation={3}
        >
          <Typography variant="h5">Connect Your Stripe Account</Typography>
          <div style={{textAlign: 'center'}}>
              <IconButton onClick={handleOpenModal} color="primary">
                <AddCircleIcon fontSize="large" />
              </IconButton>
            </div>
        </Paper>
        ) : (
          businesses.map((business, index) => (
            <div>
            <Paper
              sx={{
                mt: 4,
                p: 4,
                borderRadius: 4,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
              }}
              elevation={3}
            >
              <Box
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                display: 'flex',
                gap: 1,
              }}
            >
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEditBusiness(business.business_id)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton
                color="secondary"
                size="small"
                onClick={() => handleDeleteBusiness(business.business_id)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>

            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={8} sm={9}>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left' }}>
                  <Typography variant="h5">{business.business_name}</Typography>
                  <Typography variant="body1">
                    Post Frequency: {business.schedule}
                  </Typography>
                </Box>
              </Grid>

              {/* Right Column */}
              <Grid item xs={4} sm={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Switch
                    checked={business.posting_enabled}
                    onChange={() => handleTogglePosting(business.business_id)}
                    color="primary"
                  />
                  <Typography variant="body2">
                    Posting: {business.posting_enabled ? 'Enabled' : 'Disabled'}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
          </div>
          ))
        )}
        {businesses.length !== 0 ? (
          <div style={{textAlign: 'center'}}>
            <IconButton onClick={handleOpenModal} color="primary">
              <AddCircleIcon fontSize="large" />
            </IconButton>
          </div>
          ) : (
            <></>
          )
        }

      {/* Modal for Adding Business Details */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 4,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
        <div style={{ padding: '5px' }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              top: 8,
              left: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
          <Typography id="modal-title" variant="h6" sx={{ mb: 2 }}>
            Add Business Details
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Business Name"
                name="business_name"
                value={currentBusiness.business_name || ''}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={4}
                id="outlined-multiline-static"
                label="Post Introduction"
                name="post_introduction"
                value={currentBusiness.post_introduction || ''}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Stripe API Key"
                name="stripe_key"
                value={currentBusiness.stripe_key || ''}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Label fontWeight='bold'>Post Frequency</Label>
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                name="schedule"
                value={currentBusiness.schedule}
                onChange={handleInputChange}
              >
                <MenuItem value="Daily">Daily</MenuItem>
                <MenuItem value="Weekly">Weekly</MenuItem>
                <MenuItem value="Monthly">Monthly</MenuItem>
              </Select>
            </Grid>
            {/* Conditionally render day of week or day of month based on schedule */}
            {currentBusiness.schedule === 'Weekly' ? (
              <Grid item xs={12}>
                <Select
                  fullWidth
                  name="post_day"
                  value={currentBusiness.post_day}
                  onChange={handleInputChange}
                >
                  {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            ) : currentBusiness.schedule === 'Monthly' ? (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="number"
                  label="Day of the Month"
                  name="post_month_day"
                  value={currentBusiness.post_month_day}
                  onChange={handleInputChange}
                  inputProps={{ min: 1, max: 31 }}
                />
              </Grid>
            ) : null}

            {/* Time picker always present */}
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="post Time"
                  name="post_time"
                  value={currentBusiness.post_time}
                  minutesStep={10}
                  onChange={handleTimeChange}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleSaveBusiness}
          >
            Save
          </Button>
        </Box>
      </Modal>
    </Container>
    </div>
  );
};

export default withAuthenticator(App, {
  signUpConfig: {
    hiddenDefaults: ['phone_number'],
    signUpFields: [
      {
        label: 'Custom username',
        key: 'username',
        required: true,
        displayOrder: 1,
        type: 'string',
      },
    ],
  },
  includeGreetings: true,
  federated: {
    googleClientId: '504286488070-rpqcic2u5rs71bqsa6h0hc7bbferi25t.apps.googleusercontent.com',
  },
});
